import { createAction } from "redux-act";

export const REQNotificationList = createAction("REQUEST_NOTIFICATION_LIST");
export const RESNotificationList = createAction("RECEIVE_NOTIFICATION_LIST");
export const FailNotificationList = createAction("FAILED_NOTIFICATION_LIST");
export const SENDxNotification = createAction("SEND_NOTIFICATION_NOW");
export const DELxNotification = createAction("DELETE_NOTIFICATION");
export const SETxNotificationStatus = createAction("SET_NOTIFICATION_STATUS");
export const CleanUpNotificationList = createAction("CLEANUP_NOTIFICATION_LIST");
// Count of automatic notifications per event code, for the Automatic page's Events list.
export const REQEventCounts = createAction("REQUEST_EVENT_COUNTS");
export const RESEventCounts = createAction("RECEIVE_EVENT_COUNTS");
// The automatic CSAT settings: per-event switches and the View portfolio day limit.
export const REQCsatSetting = createAction("REQUEST_CSAT_SETTING");
export const REQSaveCsatSetting = createAction("REQUEST_SAVE_CSAT_SETTING");
export const RESCsatSetting = createAction("RECEIVE_CSAT_SETTING");
export const FailCsatSetting = createAction("FAILED_CSAT_SETTING");
